import { Type } from 'class-transformer';
import { DimensionOptionResultDto } from '../../cirabooks/shared-cirabooks-module/_models/common/dimensions/dimension-option-result-dto';

export class WorkflowItemResultDto {
    description: string;
    itemAmount: number;
    glAccountNumber: string;
    subCategory: string;

    @Type(() => DimensionOptionResultDto)
    dimensions: Array<DimensionOptionResultDto>;

    targetCommunity: string;
    apBillItemId: number;
}
